import { trpc } from '../../config/trpc';
import { ActiveRequestUsers } from '../../utils/types';

export const watcherListeners: Record<string, ((arg: string[]) => void)[]> = {};

export const useWatcherProvider = () => {
  trpc.watchingSubscription.useSubscription(undefined, {
    onData(data: ActiveRequestUsers) {
      for (const [key, setters] of Object.entries(watcherListeners)) {
        for (const setter of setters) {
          setter(data?.[key] ?? []);
        }
      }
    },
  });
};
